import { friendlyStringFromConst } from 'v1/helpers/misc';

/**
 * Display names for core resource metastructure fields.
 * Keys match `MetastructureFieldCore.name` / assignment `coreFieldKey`.
 */
export const CORE_FIELD_LABELS: Record<string, string> = {
  full_name: 'Full name',
  first_name: 'First name',
  last_name: 'Last name',
  role: 'Role',
  locations: 'Location',
  rates: 'Rate',
  tags: 'Tags',
  emails: 'Emails',
  phone_numbers: 'Phone numbers',
  websites: 'Websites',
  socials: 'Socials',
  groups: 'Groups',
  pronouns: 'Pronouns',
  profile_picture: 'Profile picture',
  contact_type: 'Contact type',
  represented_by_id: 'Represented by',
  nick_name: 'Nickname',
  import_id: 'Import ID'
};

export const CORE_FIELD_DATA_TYPE_LABEL = 'System';

export function getCoreFieldLabel(coreFieldKey: string): string {
  return CORE_FIELD_LABELS[coreFieldKey] ?? coreFieldKey;
}

export function getCoreFieldDataTypeLabel(): string {
  return CORE_FIELD_DATA_TYPE_LABEL;
}

/** A field group's type column: one block, or as many as the person adds. */
export function getFieldGroupDataTypeLabel(isArray: boolean): string {
  return isArray ? 'Field group · multiple' : 'Field group';
}

/** e.g. MULTI_SELECT → "Multi select" */
export function formatCustomFieldDataTypeLabel(dataType: string): string {
  return friendlyStringFromConst(dataType);
}
